import React from "react";
import RepeatableField from "@components/RepeatableField/RepeatablePrimitiveField";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema.ts";
import { usePortSecurityFormStore } from "@features/port-security/store/usePortSecurityForm.store.ts";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const PreviousOccupations: React.FC = () => {
  const { formData } = useOutletContext<FormContext>();

  return (
    <FormProvider {...formData}>
      <RepeatableField
        name="prevOccupations"
        sectionLabel={t("security-clearance.previous-occupations")}
        label={t("security-clearance.occupation")}
        testId="prevOccupations"
        maxChars={200}
        maxItems={6}
        onFieldChange={(key, arr) => {
          // this calls your zustand setter, e.g.:
          usePortSecurityFormStore.getState().setField(key as keyof PortSecurityFormData, arr);
        }}
        buttonLabel={t("security-clearance.add-occupation")}
        minItems={1}
      />
    </FormProvider>
  );
};

export default PreviousOccupations;
